import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

interface IProps {
    color?: string;
    style?: any;
}

export class Clear extends React.PureComponent<IProps, any> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path
                    d={`M4,21V5c0-0.5-0.4-1-1-1l0,0C2.4,4,2,4.4,2,5v17v1c0,0.5,0.4,1,1,1h1h13c0.5,0,1-0.4,1-1l0,0c0-0.5-0.4-1-1-1H5
                    C4.4,22,4,21.6,4,21z`}
                />
                <path
                    d={`M21,0H7C6.4,0,6,0.4,6,1v18c0,0.6,0.4,1,1,1h14c0.6,0,1-0.4,1-1V1C22,0.4,21.6,0,21,0z M11,17c0,0.5-0.4,1-1,1H9
                    c-0.5,0-1-0.4-1-1l0,0c0-0.5,0.4-1,1-1h1C10.6,16,11,16.4,11,17L11,17z M20,17c0,0.5-0.4,1-1,1h-5c-0.5,0-1-0.4-1-1l0,0
                    c0-0.5,0.4-1,1-1h5C19.6,16,20,16.4,20,17L20,17z M20,13c0,0.5-0.4,1-1,1H9c-0.5,0-1-0.4-1-1V3c0-0.5,0.4-1,1-1h10c0.5,0,1,0.4,1,1
                    V13z`}
                />
                <path
                    d={`M9.8,12h8.3c0.4,0,0.6-0.4,0.4-0.8l-1.3-1.9c-0.1-0.2-0.4-0.3-0.6-0.2l-2.2,0.7c-0.2,0.1-0.5,0-0.6-0.3l-1.4-2.7
                    c-0.2-0.4-0.7-0.4-0.9,0l-2.2,4.4C9.2,11.6,9.4,12,9.8,12z`}
                />
                <circle cx="17.5" cy="5.5" r="1.5" />
            </SvgIcon>
        );
    }
}

export const LinesheetsIcon = Clear;
